import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';

export const useUpdateVehicle = () => {
  const baseUrl = '/api';

  return useMutation({
    mutationFn: (value: { Id: number; Vehicle: string | null }) =>
      axiosRequest
        .put(`${baseUrl}/updateVehicle/${value.Id}`, value.Vehicle)
        .then((res) => {
          return res.data;
        }),
  });
};
